"use client";

import { Button } from "@/components/atoms/button";
import { DEFAULT_LOCALE } from "@/i18n/routing";

export default function GlobalError({
  error: _error,
  reset,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>) {
  const handleReset = () => {
    reset();
  };

  return (
    <html lang={DEFAULT_LOCALE}>
      <body>
        <main>
          <section className="bg-white">
            <div className="layout flex min-h-screen flex-col items-center justify-center text-center text-black">
              <h1 className="mt-8 text-4xl md:text-6xl">
                Something went wrong
              </h1>
              <p className="mt-4 text-lg text-gray-600">
                We apologize for the inconvenience. Please try again later.
              </p>
              <Button variant="primary" onClick={handleReset} className="mt-4">
                Try again
              </Button>
            </div>
          </section>
        </main>
      </body>
    </html>
  );
}
